import Google from "@repo/components/src/shared/login/Google";
import Microsoft from "@repo/components/src/shared/login/Microsoft";
import { VStack } from "@repo/components/src/ui/vstack";

type Props = {
  /** Checks the form before leaving for the provider; it goes only on `true`. */
  beforeSignIn?: () => Promise<boolean>;
};

/** Where the Google and Microsoft sign-ups end: the page that claims the campaign. */
const CLAIM_PATH = "/start/claim";

/** «Continuar con Google / Microsoft». Consent is asked by the form around it, or by
 * the claim after the sign-in. */
const OAuthOptions = ({ beforeSignIn }: Props) => (
  <VStack space="sm" className="w-full">
    <Google
      size="md"
      rounded="lg"
      className="w-full"
      label="Continuar con Google"
      next={CLAIM_PATH}
      beforeSignIn={beforeSignIn}
    />
    <Microsoft
      size="md"
      rounded="lg"
      className="w-full"
      label="Continuar con Microsoft"
      next={CLAIM_PATH}
      beforeSignIn={beforeSignIn}
    />
  </VStack>
);

export default OAuthOptions;
